import React, {useState} from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser"

const Timeline = ({ items, title }) => {
  const [activeYear, setActiveYear] = useState(0);

  return (
    <section className="timeline">
      <div className="timeline__inner">
        <div className="timeline__title">
          {title && <h2>{parse(title)}</h2>}
          <div className="line line--horizon center-left"></div>
        </div>
        {
          items?.length > 0 &&
          <div className="timeline__items">
            {
              items.map((el, i) => (
                <div key={i} className={`timeline__item ${i === activeYear ? 'active' : ''}`}>
                  <div className="timeline__image">
                    {el.image && <Asset asset={el.image} />}
                  </div>
                  <div className="timeline__content">
                    {el.year && <h2>{el.year}</h2>}
                    {el.title && <h3>{el.title}</h3>}
                    {el.richContent && <StructuredText data={el.richContent} />}
                  </div>
                </div>
              ))
            }
          </div>
        }

        <ul className="timeline__years">
          {
            items?.length > 0 && items.map((el, i) => (
              <li
                onMouseEnter={() => setActiveYear(i)}
                key={i} className={`timeline__year ${i === activeYear ? 'active' : ''}`}>
                {el.year}
              </li>
            ))
          }
        </ul>
      </div>
    </section>
  )
}

export default Timeline

export const query = graphql`
fragment TimelineProps on DatoCmsTimeline {
  ... on DatoCmsTimeline {
    id
    title
    items {
      title
      year
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
    }
  }
}
`